import { Spinner } from './Spinner'
import { Dots } from './Dots'

export default {
  Spinner,
  Dots,
}
